import styled, { css } from 'styled-components';

const CollapsibleStyles = styled.div`
  @media screen and (max-width: ${props => parseFloat(props.applyBelow) - 1}px) {
    ${props =>
      props.visible === false &&
      css`
        display: none;
      `};
  }
`;

export default CollapsibleStyles;
